import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editResourcesListingConfiguration(
    req: Boundaries["editResourcesListingConfiguration"]["request"],
  ): void;
}

function useEditResourcesListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditResourcesListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditResourcesListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditResourcesListingConfigurationRequestFailure(planzone),
    ),
    editResourcesListingConfiguration: core.editResourcesListingConfiguration,
  };
}

export { useEditResourcesListingConfiguration };
